import { css } from '@emotion/react';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';
import * as commonCss from '../../styles/common';
import CopyToClipboardButton from '../CopyToClipboardButton';

enum ShareOption {
  X = 'X',
  Facebook = 'Facebook',
  Whatsapp = 'Whatsapp',
  CopyLink = 'CopyLink',
}

interface SocialShareSelectorProps {
  shareData: ShareData;
  onDidShare?: (shareOption: ShareOption) => void;
}

const ICON_SIZE = 32;
const BUTTONS = [
  {
    component: TwitterShareButton,
    icon: XIcon,
    shareOption: ShareOption.X,
  },
  {
    component: FacebookShareButton,
    icon: FacebookIcon,
    shareOption: ShareOption.Facebook,
  },
  {
    component: WhatsappShareButton,
    icon: WhatsappIcon,
    shareOption: ShareOption.Whatsapp,
  },
];

export const SocialShareSelector: React.FC<SocialShareSelectorProps> = ({ shareData: { url, text }, onDidShare }) => {
  const socialShareSelectorCss = {
    button: [
      commonCss.centered,
      css({
        display: 'flex',
      }),
    ],
  };

  return (
    <IonGrid css={css({ width: '100%' })}>
      <IonRow css={commonCss.centered}>
        {BUTTONS.map(({ component: Button, icon: Icon, shareOption }) => (
          <IonCol key={shareOption}>
            <Button
              url={url!}
              title={text}
              onClick={() => onDidShare?.(shareOption)}
              css={socialShareSelectorCss.button}
            >
              <Icon size={ICON_SIZE} round></Icon>
            </Button>
          </IonCol>
        ))}
        <IonCol>
          <CopyToClipboardButton textToCopy={url!} onDidCopy={() => onDidShare?.(ShareOption.CopyLink)} />
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
